import React, { useEffect, useState, useRef, Component } from 'react';
import { SearchIcon, Settings2Icon, UserIcon, LogOutIcon, HelpCircleIcon, XIcon, LayoutGridIcon, ListIcon, Grid2x2Icon } from 'lucide-react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAppSettings } from '../../context/AppSettingsContext';
export const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [showUserMenu, setShowUserMenu] = useState(false);
  const [showMobileSearch, setShowMobileSearch] = useState(false);
  const [showMobileSettings, setShowMobileSettings] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const menuRef = useRef<HTMLDivElement>(null);
  const {
    viewMode,
    setViewMode
  } = useAppSettings();
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setShowUserMenu(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);
  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      // Navigate to search results page with query parameter
      navigate(`/apps?search=${encodeURIComponent(searchQuery.trim())}`);
    }
  };
  const showViewOptions = location.pathname === '/my-apps';
  return <header className="flex items-center justify-between px-6 py-4 border-b border-gray-200" data-id="element-151">
      {/* Left section */}
      <div className="flex items-center space-x-8" data-id="element-152">
        <Link to="/" className="flex items-center space-x-2" data-id="element-153">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/niZcL1bi9DypZftp1zanDt/RealUseIcon.svg" alt="RealUseAI" className="h-8 w-8" data-id="element-154" />
          <h1 className="text-xl font-bold bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent" data-id="element-155">
            RealUseAI
          </h1>
        </Link>
        <nav className="hidden md:flex space-x-6" data-id="element-156">
          <Link to="/my-apps" className={`${location.pathname === '/my-apps' ? 'text-indigo-600 font-medium' : 'text-gray-700 hover:text-indigo-600'}`} data-id="element-157">
            My Apps
          </Link>
          <Link to="/" className={`${location.pathname === '/' ? 'text-indigo-600 font-medium' : 'text-gray-700 hover:text-indigo-600'}`} data-id="element-158">
            Discover
          </Link>
          <Link to="/create" className={`${location.pathname === '/create' ? 'text-indigo-600 font-medium' : 'text-gray-700 hover:text-indigo-600'}`} data-id="element-159">
            Create
          </Link>
        </nav>
      </div>
      {/* Right section */}
      <div className="flex items-center space-x-4" data-id="element-160">
        {/* Desktop Search */}
        <div className="relative hidden md:block" data-id="element-161">
          <form onSubmit={handleSearch} data-id="element-162">
            <input type="text" placeholder="Search AI apps..." className="bg-gray-100 rounded-full py-2 px-4 pl-10 w-64 focus:outline-none focus:ring-2 focus:ring-indigo-500" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} data-id="element-163" />
            <SearchIcon className="absolute left-3 top-2.5 h-4 w-4 text-gray-400" data-id="element-164" />
            <button type="submit" className="sr-only" data-id="element-165">
              Search
            </button>
          </form>
        </div>
        {/* Mobile Actions */}
        <div className="flex items-center space-x-4 md:hidden" data-id="element-166">
          <button onClick={() => setShowMobileSearch(!showMobileSearch)} data-id="element-167">
            <SearchIcon className="h-6 w-6 text-gray-500" data-id="element-168" />
          </button>
          <button onClick={() => setShowMobileSettings(!showMobileSettings)} data-id="element-169">
            <Settings2Icon className="h-6 w-6 text-gray-500" data-id="element-170" />
          </button>
        </div>
        {/* User Menu (Desktop) */}
        <div className="relative hidden md:block" ref={menuRef} data-id="element-171">
          <button onClick={() => setShowUserMenu(!showUserMenu)} className="w-8 h-8 bg-indigo-500 rounded-full flex items-center justify-center text-white hover:bg-indigo-600 transition-colors" data-id="element-172">
            <span className="text-sm" data-id="element-173">JD</span>
          </button>
          {showUserMenu && <div className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg border border-gray-200 py-1 z-50" data-id="element-174">
              <div className="px-4 py-2 border-b border-gray-100" data-id="element-175">
                <p className="font-medium" data-id="element-176">John Doe</p>
                <p className="text-sm text-gray-500" data-id="element-177">john@example.com</p>
              </div>
              <button onClick={() => {
            navigate('/account');
            setShowUserMenu(false);
          }} className="w-full px-4 py-2 text-left text-sm hover:bg-gray-50 flex items-center" data-id="element-178">
                <UserIcon className="h-4 w-4 mr-2" data-id="element-179" />
                My Account
              </button>
              <button onClick={() => {
            navigate('/settings');
            setShowUserMenu(false);
          }} className="w-full px-4 py-2 text-left text-sm hover:bg-gray-50 flex items-center" data-id="element-180">
                <Settings2Icon className="h-4 w-4 mr-2" data-id="element-181" />
                Settings
              </button>
              <button onClick={() => {
            navigate('/help');
            setShowUserMenu(false);
          }} className="w-full px-4 py-2 text-left text-sm hover:bg-gray-50 flex items-center" data-id="element-182">
                <HelpCircleIcon className="h-4 w-4 mr-2" data-id="element-183" />
                Help & Support
              </button>
              <div className="border-t border-gray-100 mt-1" data-id="element-184">
                <button className="w-full px-4 py-2 text-left text-sm hover:bg-gray-50 flex items-center text-red-600" data-id="element-185">
                  <LogOutIcon className="h-4 w-4 mr-2" data-id="element-186" />
                  Log Out
                </button>
              </div>
            </div>}
        </div>
      </div>
      {/* Mobile Search Overlay */}
      {showMobileSearch && <div className="fixed inset-0 z-50 bg-white px-4 py-3 md:hidden" data-id="element-187">
          <form onSubmit={e => {
        e.preventDefault();
        if (searchQuery.trim()) {
          navigate(`/apps?search=${encodeURIComponent(searchQuery.trim())}`);
          setShowMobileSearch(false);
        }
      }} data-id="element-188">
            <div className="flex items-center" data-id="element-189">
              <input type="text" placeholder="Search AI apps..." className="flex-1 bg-gray-100 rounded-full py-2 px-4 pl-10 focus:outline-none focus:ring-2 focus:ring-indigo-500" autoFocus value={searchQuery} onChange={e => setSearchQuery(e.target.value)} data-id="element-190" />
              <button type="button" onClick={() => setShowMobileSearch(false)} className="ml-2 p-2" data-id="element-191">
                <XIcon className="h-6 w-6 text-gray-500" data-id="element-192" />
              </button>
            </div>
            <button type="submit" className="sr-only" data-id="element-193">
              Search
            </button>
          </form>
        </div>}
      {/* Mobile Settings Menu */}
      {showMobileSettings && <div className="fixed inset-0 z-50 bg-black bg-opacity-50 md:hidden" data-id="element-194">
          <div className="absolute right-0 top-0 bottom-0 w-64 bg-white shadow-lg" data-id="element-195">
            <div className="p-4" data-id="element-196">
              <div className="flex justify-between items-center mb-6" data-id="element-197">
                <h3 className="text-lg font-semibold" data-id="element-198">Settings</h3>
                <button onClick={() => setShowMobileSettings(false)} className="p-2" data-id="element-199">
                  <XIcon className="h-5 w-5 text-gray-500" data-id="element-200" />
                </button>
              </div>
              {/* View Options - Only show on My Apps page */}
              {showViewOptions && <div className="mb-6" data-id="element-201">
                  <h4 className="text-sm font-medium text-gray-500 mb-2" data-id="element-202">
                    View Options
                  </h4>
                  <div className="space-y-2" data-id="element-203">
                    <button className={`w-full flex items-center px-3 py-2 rounded-md hover:bg-gray-50 
                        ${viewMode === 'cards' ? 'bg-indigo-50 text-indigo-600' : ''}`} onClick={() => {
                setViewMode('cards');
                setShowMobileSettings(false);
              }} data-id="element-204">
                      <LayoutGridIcon className="h-5 w-5 mr-3" data-id="element-205" />
                      <span data-id="element-206">Card View</span>
                    </button>
                    <button className={`w-full flex items-center px-3 py-2 rounded-md hover:bg-gray-50
                        ${viewMode === 'list' ? 'bg-indigo-50 text-indigo-600' : ''}`} onClick={() => {
                setViewMode('list');
                setShowMobileSettings(false);
              }} data-id="element-207">
                      <ListIcon className="h-5 w-5 mr-3" data-id="element-208" />
                      <span data-id="element-209">List View</span>
                    </button>
                    <button className={`w-full flex items-center px-3 py-2 rounded-md hover:bg-gray-50
                        ${viewMode === 'tiles' ? 'bg-indigo-50 text-indigo-600' : ''}`} onClick={() => {
                setViewMode('tiles');
                setShowMobileSettings(false);
              }} data-id="element-210">
                      <Grid2x2Icon className="h-5 w-5 mr-3" data-id="element-211" />
                      <span data-id="element-212">Tile View</span>
                    </button>
                  </div>
                </div>}
              {/* User Options */}
              <div className="border-t border-gray-200 pt-6" data-id="element-213">
                <button onClick={() => {
              navigate('/account');
              setShowUserMenu(false);
            }} className="w-full flex items-center px-3 py-2 rounded-md hover:bg-gray-50" data-id="element-214">
                  <UserIcon className="h-5 w-5 text-gray-400 mr-3" data-id="element-215" />
                  <span data-id="element-216">Account Settings</span>
                </button>
                <button onClick={() => {
              navigate('/settings');
              setShowUserMenu(false);
            }} className="w-full flex items-center px-3 py-2 rounded-md hover:bg-gray-50" data-id="element-217">
                  <HelpCircleIcon className="h-5 w-5 text-gray-400 mr-3" data-id="element-218" />
                  <span data-id="element-219">Help & Support</span>
                </button>
                <button className="w-full flex items-center px-3 py-2 rounded-md hover:bg-gray-50 text-red-600" data-id="element-220">
                  <LogOutIcon className="h-5 w-5 mr-3" data-id="element-221" />
                  <span data-id="element-222">Log Out</span>
                </button>
              </div>
            </div>
          </div>
        </div>}
    </header>;
};